import { createContext } from "react";

// Used to pass down the IDs of the current (or most-recently visited) project and deployment.
export const ProjectAndDeploymentIdsContext = createContext<
  [string | undefined, string | undefined]
>([undefined, undefined]);
